import { render, staticRenderFns } from "./perfectMsg.vue?vue&type=template&id=76c38f39&scoped=true"
import script from "./perfectMsg.vue?vue&type=script&lang=ts"
export * from "./perfectMsg.vue?vue&type=script&lang=ts"
import style0 from "./perfectMsg.vue?vue&type=style&index=0&id=76c38f39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c38f39",
  null
  
)

export default component.exports